/* eslint react/no-unused-state: 1 */
/* eslint react/require-default-props: 1 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import InputMask from 'react-input-mask';

class FormInput extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      filled: false,
    };
  }

  componentDidMount() {
    const { value } = this.props;
    this.setFilled(value);
  }

  componentWillReceiveProps(nextProps) {
    this.setFilled(nextProps.value);
  }

  onChange = e => {
    const { onChange } = this.props;
    const {
      target: { value },
    } = e;

    this.setFilled(value);

    if (onChange) {
      e.persist();
      onChange(value, e);
    }
  };

  onFocus = e => {
    const { onFocus } = this.props;
    if (onFocus) {
      e.persist();
      onFocus(e);
    }
  };

  onBlur = e => {
    const { onBlur } = this.props;
    if (onBlur) {
      e.persist();
      onBlur(e);
    }
  };

  onKeyDown = e => {
    e.persist();
    const { onPressEnter } = this.props;
    if (onPressEnter && e.keyCode === 13) {
      onPressEnter(e);
    }
    const { onKeyDown } = this.props;
    if (onKeyDown) {
      onKeyDown(e);
    }
  };

  setInputRef = ref => {
    this.inputRef = ref;
    const { inputRef } = this.props;
    if (inputRef) {
      inputRef(ref);
    }
  };

  setFilled(value) {
    this.setState({ filled: !!value });
  }

  render() {
    const {
      groupClassName,
      type,
      label,
      placeholder,
      inputName,
      value,
      disabled,
      invalid,
      autocomplete,
      errorMessage,
      mask,
      hideMask,
      autoFocus,
      children,
    } = this.props;

    return (
      <div className={cn(groupClassName, errorMessage && 'has-error')}>
        {mask ? (
          <InputMask
            ref={this.setInputRef}
            className="form-control"
            value={value}
            disabled={disabled}
            id={inputName}
            name={inputName}
            placeholder={placeholder}
            type={type}
            onChange={this.onChange}
            onBlur={this.onBlur}
            onFocus={this.onFocus}
            onKeyDown={this.onKeyDown}
            autoComplete={autocomplete}
            mask={mask}
            maskChar={!hideMask && '_'}
            autoFocus={autoFocus}
          />
        ) : (
          <input
            ref={this.setInputRef}
            className={cn('form-control', invalid && 'has-error')}
            value={value || ''}
            disabled={disabled}
            id={inputName}
            name={inputName}
            placeholder={placeholder}
            type={type}
            onChange={this.onChange}
            onBlur={this.onBlur}
            onFocus={this.onFocus}
            onKeyDown={this.onKeyDown}
            autoComplete={autocomplete}
            autoFocus={autoFocus} // eslint-disable-line jsx-a11y/no-autofocus
          />
        )}
        {children}
        {errorMessage && (
          <label htmlFor={inputName} className="help-block">
            {errorMessage.length > 1 ? errorMessage.join(', ') : errorMessage}
          </label>
        )}
      </div>
    );
  }
}

FormInput.propTypes = {
  errorMessage: PropTypes.string,
  autocomplete: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  inputName: PropTypes.string.isRequired,
  type: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onPressEnter: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyDown: PropTypes.func,
  inputRef: PropTypes.func,
  autoFocus: PropTypes.bool,
  mask: PropTypes.string,
  hideMask: PropTypes.bool,
  groupClassName: PropTypes.string,
  children: PropTypes.node,
  placeholder: PropTypes.string,
  invalid: PropTypes.bool,
};

FormInput.defaultProps = {
  groupClassName: 'form-group',
  mask: null,
  hideMask: false,
  errorMessage: null,
  children: null,
  disabled: false,
  invalid: false,
  autocomplete: 'off',
  label: null,
  type: 'text',
  value: null,
};

export default FormInput;



// WEBPACK FOOTER //
// ./app/javascript/pro_platform_sign_up/components/FormInput.js